/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React from 'react'
import styled from 'styled-components'
import { Dropdown as DropdownBs } from '@bootstrap-styled/v4'
import classNames from 'classnames'
import { drawCaret } from '../../../styles/mixins'
import { omit } from 'ramda'

// type definition
export type DropdownProps = {
    className?: string
    dropright?: boolean
} & React.ComponentProps<typeof DropdownBs>

// Dropdown component styled
const Dropdown = styled(
    (attrs: DropdownProps): JSX.Element => <DropdownBs {...omit(['dropright'], attrs)} />
).attrs(({ dropright, ...props }) => ({
    className: classNames(props.className, { dropright }),
    dropup: props.dropup && !dropright
}))`
    && .dropdown-toggle {
        &::after {
            ${drawCaret('down', true, -1)}
        }

        &.alternate {
            &.active::after {
                ${drawCaret('up', false)}
            }
        }

        &.btn-link {
            text-decoration: none;
            font-weight: ${props => props.theme['$font-weight-medium']};
        }
    }

    &.dropup {
        .dropdown-toggle {
            &::after {
                ${drawCaret('up', true, -1)}
            }

            &.alternate {
                &.active::after {
                    ${drawCaret('down', false)}
                }
            }
        }

        .dropdown-menu {
            border-width: ${props => props.theme['$dropdown-border-width']} !important;
            border-bottom: ${props =>
                `${props.theme['$dropdown-menu-border-width']} solid ${props.theme['$primary']}`} !important;
        }
    }

    &.dropright {
        position: relative;

        .dropdown-menu {
            top: 0;
            right: auto;
            left: 100%;
            margin-top: 0;
            margin-left: ${props => props.theme['$dropdown-spacer']};
            border-width: ${props => props.theme['$dropdown-border-width']} !important;
            border-left: ${props =>
                `${props.theme['$dropdown-menu-border-width']} solid ${props.theme['$primary']}`} !important;
        }

        .dropdown-toggle {
            &::after {
                ${drawCaret('right', true, -1)}
            }

            &.alternate {
                &.active::after {
                    ${drawCaret('down', false)}
                }
            }
        }
    }

    && .dropdown-menu {
        border-top: ${props =>
            `${props.theme['$dropdown-menu-border-width']} solid ${props.theme['$primary']}`};

        .list-data {
            margin: 0;
            padding: ${props => props.theme['$spacer']};
            color: ${props => props.theme['$gray']};
            font-size: ${props => props.theme['$font-size-base']};
            font-weight: ${props => props.theme['$font-weight-medium']};
            white-space: nowrap;

            dt {
                margin-bottom: ${props => props.theme['$dropdown-padding-y']};
            }
            dd {
                margin-bottom: 0px;
            }
        }
    }

    && .dropdown-header {
        padding: ${props =>
            `${props.theme['$dropdown-item-padding-y']} ${props.theme['$dropdown-item-padding-x']}`};
    }

    && .dropdown-item {
        padding: ${props =>
            `${props.theme['$dropdown-item-padding-y']} ${props.theme['$dropdown-item-padding-x']}`};
        font-size: ${props => props.theme['$dropdown-font-size']};
        font-weight: ${props => props.theme['$font-weight-medium']};
    }
`

export default Dropdown
